import { Button, ButtonProps, Tooltip } from '@nextui-org/react';
import { PiFileTxtFill } from 'react-icons/pi';
import Icon from '../base/Icon';

export default function ButtonExportTxt(props: ButtonProps) {
  return (
    <Tooltip content="Export as plain text" placement="bottom">
      <Button {...props}>
        <Icon icon={PiFileTxtFill} className="w-4 h-4" />
      </Button>
    </Tooltip>
  );
}
